module.exports = __webpack_public_path__ + "search.fe4b1508.png";